import { render, staticRenderFns } from "./leftMenu.vue?vue&type=template&id=0b24f3da&scoped=true"
import script from "./leftMenu.vue?vue&type=script&lang=js"
export * from "./leftMenu.vue?vue&type=script&lang=js"
import style0 from "./leftMenu.vue?vue&type=style&index=0&id=0b24f3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24f3da",
  null
  
)

export default component.exports